import { createContext } from 'react'

const creditosContext = createContext();

export default creditosContext;